import { Controller } from "@hotwired/stimulus"

// Invia il form appena un campo cambia: il RoleSelect di Persone.js salva il ruolo alla scelta (onValueChange).
// Con `ripristina` (saveStadio di ProjectDetail.js, che rimette `prima` a ogni errore) un invio non riuscito riporta il
// menu all'ultimo valore salvato, quale che sia l'errore (anche 403 e 404, a cui il server risponde col solo toast);
// un invio riuscito fa del valore scelto il nuovo valore salvato.
export default class extends Controller {
  static values = { ripristina: Boolean }

  invia() {
    this.element.requestSubmit()
  }

  // turbo:submit-end
  fine(event) {
    if (!this.ripristinaValue) return
    if (event.detail.success) {
      this.element.querySelectorAll("select").forEach((s) => [...s.options].forEach((o) => { o.defaultSelected = o.selected }))
    } else {
      this.element.reset()
    }
  }
}
